// extracted by mini-css-extract-plugin
export default {"wrapper_input":"styles_wrapper_input__L2KFm","input":"styles_input__2Qi+P","buttonDeleteSearch":"styles_buttonDeleteSearch__wZP5N"};